import React from 'react';
import { Container, Grid, Typography, Button, Box } from '@mui/material';
import googleplay from "../images/google-play.png";

const DownloadAppSection = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                padding: {
                  xs: '2rem 0 0 0',  // For small devices (xs breakpoint), only top padding
                  sm: '5rem 5.5rem 1.5rem',  // For larger screens (sm and above)
                },
                borderRadius: '28px',
               
              }}
            >
              <Typography variant="h4" sx={{  marginBottom: '1rem',  fontSize: "2rem",}}>
              Download our App now
              </Typography>
              <Typography variant="body1" sx={{  marginBottom: '2.75rem' }}>
              Our app securely stores all your essential financial information, including mutual funds, demat trading, insurance details, investment accounts, property, bond details, gold and other assets and vehicle information and more general information also, ensuring your data is safe and easily accessible whenever you need it.
              </Typography>
              {/* <Button
                variant="contained"
                sx={{
                  backgroundColor: '#16c66d',
                  borderColor: '#16c66d',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    borderColor: '#ffffff',
                    color: '#ffffff',
                  },
                }}
                href="#contact"
              >
                Get free quote
              </Button> */}
                <Button 
                component="a" 
                href="https://play.google.com/store/apps/details?id=com.fastura.myfinanza&hl=en" 
                target="_blank"
                sx={{ p: 0 }}
              >
                <Box 
                  component="img" 
                  src={googleplay}
                  alt="Google Play" 
                  sx={{ width: 160 }}
                />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DownloadAppSection;
